export default __webpack_public_path__ + "static/media/write-a-story.a047687d.jpg";